export default "__VITE_ASSET__d0731a89__"